import { IconProps } from './IconProps';

export function SealIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_7156_44872)">
                <path
                    d="M4 19.5C3.13284 19.665 2.33536 20.087 1.71118 20.7112C1.087 21.3354 0.664998 22.1328 0.5 23H5C5.57699 22.982 6.13256 22.7773 6.58333 22.4167C7.0341 22.056 7.35575 21.559 7.5 21"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.82 23H23.5C23.4896 22.2893 23.2357 21.6038 22.7807 21.0578C22.3257 20.5118 21.6971 20.1384 21 20C20.5771 19.9048 20.1388 19.9009 19.7142 19.9885C19.2897 20.0761 18.8887 20.2532 18.538 20.508C18.1831 18.9178 17.2858 17.5007 16 16.5C13.569 14.416 8 15 8 15C8 15 7.877 11.816 7 10.5C6.2445 9.5244 5.19113 8.82215 4 8.5C3 9.5 1.5 11.134 1.5 15C1.5 16.714 1.5 18.5 2.5 20"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.25 8.5C6.32107 8.5 8 6.82107 8 4.75C8 2.67893 6.32107 1 4.25 1C2.17893 1 0.5 2.67893 0.5 4.75C0.5 6.82107 2.17893 8.5 4.25 8.5Z"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.85818 1.85938C1.85818 1.85938 1.49818 4.49937 2.99818 5.99937C3.99898 6.92716 5.27603 7.50178 6.63418 7.63538C6.65077 6.33356 6.25293 5.0602 5.49818 3.99938C4.56018 2.89682 3.27773 2.14285 1.85818 1.85938Z"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.25 12C5.11193 12 5 11.8881 5 11.75C5 11.6119 5.11193 11.5 5.25 11.5"
                    stroke="#66182A"
                />
                <path
                    d="M5.25 12C5.38807 12 5.5 11.8881 5.5 11.75C5.5 11.6119 5.38807 11.5 5.25 11.5"
                    stroke="#66182A"
                />
            </g>
            <defs>
                <clipPath id="clip0_7156_44872">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
